import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject, from, switchMap } from 'rxjs';
import { loadScript } from 'shared-ui/di/load-script';
import { loadStyle } from 'shared-ui/di/load-style';
import { PPL } from 'shared-ui/providers/ppl';
import { PplPickupComponent } from 'shared-ui/providers/ppl-pickup.component';

@Injectable({ providedIn: 'root' })
export class PplPickup {
  private dialog = inject(MatDialog);
  point = new Subject<null | PPL['Point']>();

  constructor() {
    document.addEventListener('ppl-parcelshop-map' as any, (event: CustomEvent<PPL['Point']>) => {
      this.point.next(event.detail);
    });
  }

  pick(): Observable<null | PPL['Point']> {
    const dialog = this.dialog.open(PplPickupComponent, {
      maxWidth: '100vw',
      width: 'calc(100vw - 32px)',
      height: 'calc(100vh - 32px)',
    });
    return from(this.loadClient()).pipe(switchMap(() => dialog.afterClosed()));
  }

  private async loadClient() {
    await loadScript('https://www.ppl.cz/sources/map/main.js');
    await loadStyle('https://www.ppl.cz/sources/map/main.css');
  }
}
